module.exports = __webpack_public_path__ + "public/adminIcons/RentALL-logo.png?c57c43f0";